import { useEffect } from 'react';

const SITE = 'https://surophone.fr';

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (path) => {
  const el = document.querySelector('link[rel="canonical"]');
  if (!el) return () => {};
  const prev = el.getAttribute('href');
  el.setAttribute('href', `${SITE}${path}`);
  return () => el.setAttribute('href', prev);
};

const injectJsonLd = (data) => {
  if (!data) return () => {};
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = 'page-jsonld';
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
  return () => script.remove();
};

/** Met à jour title, meta description, canonical et JSON-LD de la page courante. */
export const useSEO = ({ title, description, path, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    if (description) setMeta('description', description);
    const restoreCanonical = path ? setCanonical(path) : () => {};
    const removeJsonLd = injectJsonLd(jsonLd);
    return () => {
      restoreCanonical();
      removeJsonLd();
    };
  }, [title, description, path, jsonLd]);
};
